import React from 'react';
import { compose } from 'recompose';
import { withStyles } from '@material-ui/core/styles';

import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import Input from '@material-ui/core/Input';

import { commonStyles } from '../../styles/styles';

const VersionNameField = ({ classes, meta, input }) => {
  const conditionError = meta.error && meta.touched;
  return (
    <FormControl
      className={classes.formField}
      aria-describedby="name-error-text"
      error={conditionError}
    >
      <Input
        {...input}
        className={`${classes.formInput} ${conditionError ? classes.inputError : false}`}
        name="versionName"
        type="text"
        placeholder="Name this version"
        label="Name this version"
        disableUnderline
        autoComplete="off"
        error={conditionError}
        classes={{ focused: classes.formInputFocus }}
      />
      {conditionError && (
        <FormHelperText id="name-error-text" className={styles.errorBottomText}>
          {meta.error}
        </FormHelperText>
      )}
    </FormControl>
  );
};

const styles = () => ({
  ...commonStyles,
});

export default compose(withStyles(styles))(VersionNameField);
